<template>
    <div v-if="show" class="custom-modal-overlay-ambiente">
        <div class="custom-modal-ambiente">
            <div v-if="isGlobalLoadingView && !hasPreparationErrorView" class="spinner-simple"></div>
            <h3 class="modal-title-ambiente">Preparando seu ambiente…</h3>
            <p class="description-preparacao-ambiente">
                Caro parceiro, estamos preparando o seu ambiente para uma melhor experiência.
                Esse processo pode levar alguns segundos.
            </p>
            <ul class="steps-preparacao">
                <li>
                    <span class="check-icon-preparacao"></span>
                    <span class="step-text-preparacao">Buscando configurações</span>
                </li>
                <li>
                    <template v-if="!hasPreparationErrorView">
                        <div v-if="loading" class="spinner-simple-small"></div>
                        <span class="step-text-preparacao">
                            <span v-if="retryCount > 0">{{ retryCount === 1 ? '[Tentativa 1]' : '[Retentativa ' + retryCount + ']' }}</span>
                            Preparando condições de venda...
                        </span>
                    </template>
                    <template v-else>
                        <span class="error-icon-retry">❌</span>
                        <span class="step-text-preparacao">
                            [Retentativa {{ retryCount }}] Preparando condições de venda
                        </span>
                    </template>
                </li>
            </ul>
            <div v-if="showFinalError" class="error-message-retry">
                <p><strong>Erro:</strong> {{ errorMessage }}</p>
            </div>
            <div v-if="showFinalError" class="action-buttons-retry">
                <button class="preparacao-btn btn-retry" @click="retryProcess">TENTAR NOVAMENTE</button>
                <button class="preparacao-btn btn-list-link" @click="goToSales">LISTAGEM DE VENDAS</button>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'PreparacaoAmbienteBroker',
    props: {
      show: { type: Boolean, default: false },
      pedido: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        isGlobalLoading: true,
        hasPreparationError: false,
        showFinalError: false,
        retryCount: 0,
        maxRetries: 3,
        errorMessage: ''
      }
    },
    computed: {
      isGlobalLoadingView () {
        return this.isGlobalLoading
      },
      hasPreparationErrorView () {
        return this.hasPreparationError
      }
    },
    watch: {
      show: {
        immediate: true,
        handler (val) {
          if (val) this.startPreparation()
        }
      }
    },
    methods: {
      async startPreparation (manual = false) {
        this.hasPreparationError = false
        this.showFinalError = false
        if (!manual) this.retryCount = 0
        this.loading = true
        this.isGlobalLoading = true

        const id_unidade_negocio = this.$session.get('id_unidade_negocio')
        const id_ponto_venda = this.$session.get('id_ponto_venda')
        const id_comissionado = this.$session.get('id_comissionado_venda')
        const id_empresa = this.$session.get('id_empresa')
        const id_reserva = this.pedido?.id_reserva ?? 0
        const id_produto = this.pedido?.produto?.id_produto ?? this.pedido?.id_produto ?? 0

        if (manual) {
          this.retryCount++
          await this.tryPreparationRequest(id_unidade_negocio, id_ponto_venda, id_comissionado, id_empresa, id_reserva, id_produto, true)
          return
        }

        for (let i = 1; i <= this.maxRetries; i++) {
          this.retryCount = i
          const success = await this.tryPreparationRequest(id_unidade_negocio, id_ponto_venda, id_comissionado, id_empresa, id_reserva, id_produto, i)
          if (success) return
        }
      },
      async tryPreparationRequest (id_unidade_negocio, id_ponto_venda, id_comissionado, id_empresa, id_reserva, id_produto, manual = false, attempt = 1) {
        try {
          const payload = {
            ID_Ponto_Venda: id_ponto_venda,
            ID_Unidade_Negocio: id_unidade_negocio,
            ID_Comissionado: id_comissionado,
            ID_Empresa: id_empresa,
            ID_Reserva: id_reserva,
            ID_Produto: id_produto
          }

          const response = await this.$http.post('/preparacao_ambiente', payload, { options: { silent: true } })

         if (response.data && response.data.result && response.data.result.data && response.data.result.data.NM_Tabela_Venda) {
            const nomeTabelaVenda = response.data.result.data.NM_Tabela_Venda
            this.$session.set('nm_tabela_venda', nomeTabelaVenda)
          }

          if (response.data && response.data.showModalBroker === true) {
            this.finishProcess()
            return true
          }
        } catch (err) {
          this.hasPreparationError = true
          console.warn(`Tentativa ${attempt} falhou`, err)

          if (manual || attempt === this.maxRetries) {
            this.handleFinalError(err)
          } else {
            await this.delay(3000)
            this.hasPreparationError = false
          }
        }
        return false
      },
      finishProcess () {
        this.loading = false
        this.isGlobalLoading = false
        this.hasPreparationError = false
        this.showFinalError = false
        this.$emit('finished')
      },
      handleFinalError (err) {
        this.loading = false
        this.isGlobalLoading = false
        this.hasPreparationError = true
        this.showFinalError = true
        const mensagens = err?.response?.data?.mensagens

        if (Array.isArray(mensagens) && mensagens.length) {
          this.errorMessage = mensagens.join('. ') + '.'
        } else if (typeof mensagens === 'string') {
          this.errorMessage = mensagens
        } else {
          this.errorMessage = 'Erro ao preparar condições de venda.'
        }
      },
      retryProcess () {
        this.startPreparation(true)
      },
      goToSales () {
        this.$emit('goToSales')
      },
      delay (ms) {
        return new Promise(resolve => setTimeout(resolve, ms))
      }
    }
  }
</script>

<style lang="scss" scoped>
.custom-modal-overlay-ambiente {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000000;
}

.custom-modal-ambiente {
  background: #fff;
  border-radius: 16px;
  width: 600px;
  max-width: 90%;
  padding: 30px 40px;
  text-align: center;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
  color: var(--primary);
}

.spinner-simple,
.spinner-simple-small {
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--secondary);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

.spinner-simple-small {
  width: 16px;
  height: 16px;
  margin: 0 10px 0 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-title-ambiente {
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 12px;
  color: var(--primary);
}

.description-preparacao-ambiente {
  font-size: 14px;
  line-height: 1.5;
  color: var(--primary);
  margin-bottom: 20px;
}

.steps-preparacao {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 5rem;

  li {
    display: flex;
    align-items: center;
    margin: 10px 0;
    font-size: 14px;
    width: 100%;
    max-width: 300px;

    .step-text-preparacao {
      font-weight: 600;
      color: var(--primary);
      flex-grow: 1;
      text-align: left;
    }

    .check-icon-preparacao,
    .spinner-simple-small {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    .check-icon-preparacao {
      border-radius: 50%;
      background-color: var(--secondary);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      &::after {
        content: '✔';
        color: #fff;
        font-size: 11px;
        font-weight: bold;
      }
    }

    .spinner-simple-small {
      width: 20px;
      height: 20px;
      border: 2px solid #f3f3f3;
      border-top: 2px solid var(--secondary);
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }
  }
}

.error-icon-retry {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.error-message-retry {
  margin-top: 10px;
  color: var(--primary);
  font-weight: 600;
}

.action-buttons-retry {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.preparacao-btn {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.btn-retry {
  background-color: var(--primary);
  color: #fff;
  border: none;

  &:hover {
    opacity: 0.9;
  }
}

.btn-list-link {
  background: none;
  border: none;
  color: var(--primary);
  text-decoration: underline;
  font-weight: 600;

  &:hover {
    opacity: 0.8;
  }
}
</style>
